import { AlertCondition, AlertFieldDefinition } from '@/types';

export const isAlertConditionValueComplete = (
    condition: AlertCondition,
    fieldType?: AlertFieldDefinition['type'],
): boolean => {
    if (!fieldType || condition.operator === 'changed') {
        return Boolean(fieldType);
    }

    if (condition.operator === 'between') {
        return (
            Array.isArray(condition.value) &&
            condition.value.length === 2 &&
            condition.value.every((value) =>
                typeof value === 'number' ? Number.isFinite(value) : value.trim().length > 0,
            )
        );
    }

    if (condition.operator === 'withinDays') {
        return typeof condition.value === 'number' && Number.isFinite(condition.value) && condition.value >= 0;
    }
    if (fieldType === 'number') {
        return typeof condition.value === 'number' && Number.isFinite(condition.value);
    }

    return typeof condition.value === 'string' && condition.value.trim().length > 0;
};
